import { Component, Input, OnInit } from '@angular/core';
import { SetImmagini } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-media-image',
  templateUrl: './sample-media-image.component.html',
  styleUrls: ['./sample-media-image.component.scss']
})
export class SampleMediaImageComponent implements OnInit {

  @Input() block: SetImmagini = {} as SetImmagini;
  @Input() column: string = '';
  @Input() isCarousel: boolean = false;
  public classItem: string = '';
  public domainWebsite = environment.urlApi;
  public imgPath = "";

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.immagine, "src");
    this.setColumnItem();
  }

  private setColumnItem() {
    if (this.column === '4') {
      this.classItem = 'col-9 m-auto';
    } else {
      this.classItem = 'col-12';
    }
  }

}
